'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var initialState = {
  apiProxyUrl: '',
  universalLoginApiUrl: '',
  agreement: [],
  captchaSiteKey: '',
  envPrefix: '',
  excludeFacebook: false,
  excludeFacebookApp: [],
  excludeHeader: false,
  features: [],
  fbAppId: '',
  isSecured: '',
  version: '',
  segmentKey: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  return state;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/appInfo.js
// module id = 2038
// module chunks = 0